import { useQuery } from "@tanstack/react-query";
import { getPricingUnitsForSelect } from "../../api/apiPricingUnits";
import i18next from "i18next";

const useGetPricingUnitsForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["PricingUnits-for-select", i18next.language],
        queryFn: getPricingUnitsForSelect,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetPricingUnitsForSelect;
